import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { VideoStatus, VideoPlaybackView } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import { AssetItemPreviewBase } from './asset-preview-base/asset-item-preview-base';
import { NonActiveVideoPreview } from './non-active-video-preview';

export const VideoPreview = ({
  itemInfo,
  totalCount,
  currentIndex,
  onNext,
  onPrevious,
  shouldHideContent,
  i18n,
}) => {
  const { thumbnailUrl, url, status } = itemInfo;

  const onRenderPreviewContent = useCallback(() => {
    if (status === VideoStatus.Active) {
      return (<VideoPlaybackView src={url} thumbnailUrl={thumbnailUrl} />);
    }

    return (<NonActiveVideoPreview status={status} i18n={i18n} />);
  }, [thumbnailUrl, url, status, i18n]);

  return (
    <AssetItemPreviewBase
      itemData={itemInfo}
      totalCount={totalCount}
      currentIndex={currentIndex}
      onNext={onNext}
      onPrevious={onPrevious}
      shouldHideContent={shouldHideContent}
      i18n={i18n}
      onRenderPreviewContent={onRenderPreviewContent}
    />
  );
};

VideoPreview.propTypes = {
  videoInfo: PropTypes.shape({
    url: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    status: PropTypes.string,
  }),
  totalCount: PropTypes.number.isRequired,
  currentIndex: PropTypes.number.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
  shouldHideContent: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

VideoPreview.defaultProps = {
  shouldHideContent: false,
  videoInfo: null,
};
